module.exports = __webpack_public_path__ + "img/headportrait12.878b9bb1.png";